import { call, put, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { createLicense, fetchLicenses, deleteLicense, updateLicense, changeLicenseStatus, fetchLicenseUsage } from '../../api/settingApi';
import * as types from '../constants/settingConstants';

const LICENSE_USAGE_TOAST_ID = 'license-usage-404';

function* createLicenseSaga(action) {
  try {
    const response = yield call(createLicense, action.payload);
    yield put({ type: types.CREATE_LICENSE_SUCCESS, payload: { data: response.response || response, status: response.status } });
    const successMessage = response.message || 'License created successfully!';
    toast.success(successMessage);
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to create license';
    yield put({ type: types.CREATE_LICENSE_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
  }
}

function* getLicensesSaga(action) {
  try {
    const response = yield call(fetchLicenses, action.payload);
    yield put({ type: types.GET_LICENSES_SUCCESS, payload: response });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch licenses';
    yield put({ type: types.GET_LICENSES_FAILURE, payload: errorMessage });
  }
}

function* deleteLicenseSaga(action) {
  try {
    const response = yield call(deleteLicense, action.payload);
    yield put({ type: types.DELETE_LICENSE_SUCCESS, payload: { id: action.payload, status: response.status } });
    const successMessage = response.message || 'License deleted successfully!';
    toast.success(successMessage);
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to delete license';
    yield put({ type: types.DELETE_LICENSE_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
  }
}

function* updateLicenseSaga(action) {
  try {
    const response = yield call(updateLicense, action.payload);
    yield put({ type: types.UPDATE_LICENSE_SUCCESS, payload: { data: response.response || response, status: response.status } });
    const successMessage = response.message || 'License updated successfully!';
    toast.success(successMessage);
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to update license';
    yield put({ type: types.UPDATE_LICENSE_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
  }
}

function* changeLicenseStatusSaga(action) {
  try {
    const response = yield call(changeLicenseStatus, action.payload);
    yield put({ type: types.CHANGE_LICENSE_STATUS_SUCCESS, payload: { data: response.response || response, status: response.status } });
    const successMessage = response.message || 'License status changed successfully!';
    toast.success(successMessage);
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to change license status';
    yield put({ type: types.CHANGE_LICENSE_STATUS_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
  }
}

function* getLicenseUsageSaga(action) {
  try {
    const response = yield call(fetchLicenseUsage, action.payload);
    yield put({ type: types.GET_LICENSE_USAGE_SUCCESS, payload: response });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch license usage';
    const errorStatus = error.response?.status;
    yield put({ type: types.GET_LICENSE_USAGE_FAILURE, payload: { message: errorMessage, status: errorStatus } });
    if (errorStatus === 404 && !toast.isActive(LICENSE_USAGE_TOAST_ID)) {
      toast.warning(errorMessage, { toastId: LICENSE_USAGE_TOAST_ID });
    }
  }
}

function* settingSaga() {
  yield takeEvery(types.CREATE_LICENSE_REQUEST, createLicenseSaga);
  yield takeEvery(types.GET_LICENSES_REQUEST, getLicensesSaga);
  yield takeEvery(types.DELETE_LICENSE_REQUEST, deleteLicenseSaga);
  yield takeEvery(types.UPDATE_LICENSE_REQUEST, updateLicenseSaga);
  yield takeEvery(types.CHANGE_LICENSE_STATUS_REQUEST, changeLicenseStatusSaga);
  yield takeEvery(types.GET_LICENSE_USAGE_REQUEST, getLicenseUsageSaga);
}

export default settingSaga;